import { Injectable } from '@angular/core';

/** Tracks pending "new messages" dialog to show after login (on dashboard). */
@Injectable({ providedIn: 'root' })
export class MessagesNotificationService {
  /** Set by login when user has unread messages; consumed by dashboard, then cleared. */
  pendingLoginUnreadCount: number | null = null;

  setPendingLoginDialog(unreadCount: number): void {
    this.pendingLoginUnreadCount = unreadCount;
  }

  consumePendingLoginDialog(): number | null {
    const count = this.pendingLoginUnreadCount;
    this.pendingLoginUnreadCount = null;
    return count;
  }
}
